/* GraceYes — the bag. Markup and notes: snippets/gy-cart.liquid. Rules: snippets/gy-offers.liquid. */
(function () {
  'use strict';
  var O = window.GYOffers;
  var root = document.getElementById('GyBag');
  if (!O || !root || !window.fetch) { return; }

  var elRewards = root.querySelector('[data-gyc-rewards]');
  var elBody = root.querySelector('[data-gyc-body]');
  var elFoot = root.querySelector('[data-gyc-foot]');
  var elCount = root.querySelector('[data-gyc-count]');
  var CART = O.cartUrl.replace(/\/+$/, '');
  var cart = null, catalog = null, byHandle = {}, byId = {}, lastFocus = null, changed = false, codeMsg = '';

  /* ------------------------------------------------------------ definitions */
  var BUNDLES = O.bundles.split(';').map(function (row) {
    var p = row.split('|');
    return { key: p[0].trim(), name: p[1], items: (p[2] || '').split(',').map(function (h) { return h.trim(); }) };
  }).filter(function (b) { return b.items.length > 1; });
  var PAIRS = {};
  O.pairs.split(';').forEach(function (row) {
    var p = row.split('>');
    if (p.length === 2) { PAIRS[p[0].trim()] = p[1].split(',').map(function (h) { return h.trim(); }); }
  });
  /* Milestones in order: free shipping first, then the percentage tiers. */
  var STEPS = (O.freeShip > 0 ? [{ at: O.freeShip, label: 'Free shipping', short: 'Free ship', icon: true }] : [])
    .concat(O.tiers.map(function (t) { return { at: t[0], pct: t[1], label: t[1] + '% off', short: t[1] + '% off' }; }));

  /* ---------------------------------------------------------------- helpers */
  function money(paise) {
    var r = paise / 100;
    return '₹' + r.toLocaleString('en-IN', { minimumFractionDigits: r % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function api(path, body) {
    var opt = { credentials: 'same-origin', headers: { 'Accept': 'application/json' } };
    if (body) {
      opt.method = 'POST';
      if (body instanceof FormData) { opt.body = body; }
      else { opt.headers['Content-Type'] = 'application/json'; opt.body = JSON.stringify(body); }
    }
    return fetch(CART + path, opt).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) { throw j; } return j; });
    });
  }
  function tierFor(subtotal) {
    var pct = 0;
    O.tiers.forEach(function (t) { if (subtotal >= t[0]) { pct = t[1]; } });
    return pct;
  }
  /* What a basket of this size ends up as: discount, shipping, total. */
  function outcome(subtotal) {
    var pct = tierFor(subtotal);
    var after = Math.round(subtotal * (100 - pct) / 100);
    return { pct: pct, after: after, free: after >= O.freeShip };
  }
  function stepsReached(subtotal, after) {
    return STEPS.filter(function (s) { return s.pct ? subtotal >= s.at : after >= s.at; }).length;
  }

  /* ----------------------------------------------------------------- state */
  /* Shopify is the source of truth for discounts. If the cart carries none of
     its own but a milestone has been reached, the automatic discount is either
     switched off or has not caught up, so the milestone is shown as an estimate. */
  function estimate(c) {
    var sub = c.items_subtotal_price;
    var real = c.total_discount > 0 || (c.cart_level_discount_applications || []).length > 0;
    var pct = tierFor(sub);
    var est = (!real && pct) ? Math.round(sub * pct / 100) : 0;
    var total = c.total_price - est;
    var free = total >= O.freeShip;
    return { sub: sub, pct: pct, est: est, total: total, free: free, ship: free ? 0 : O.shipFee, real: real };
  }

  function loadCatalog() {
    if (catalog) { return Promise.resolve(catalog); }
    try {
      var cached = JSON.parse(sessionStorage.getItem('gyCatalog') || 'null');
      if (cached && cached.at > Date.now() - 15 * 60 * 1000) { setCatalog(cached.products); return Promise.resolve(catalog); }
    } catch (e) {}
    return fetch(O.catalogUrl, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (t) {
      var data = JSON.parse(t);
      setCatalog(data.products);
      try { sessionStorage.setItem('gyCatalog', JSON.stringify({ at: Date.now(), products: data.products })); } catch (e) {}
      return catalog;
    })['catch'](function () { setCatalog([]); return catalog; });
  }
  function setCatalog(list) {
    catalog = list || [];
    catalog.forEach(function (p) { byHandle[p.h] = p; byId[p.id] = p; });
  }

  function refresh() {
    return Promise.all([api('.js'), loadCatalog()]).then(function (res) { cart = res[0]; render(); return cart; });
  }
  function busy(on) { root.classList.toggle('is-busy', !!on); }
  function done() { busy(false); }
  function mutate(promise) {
    busy(true); changed = true;
    return promise.then(refresh)['catch'](function (err) {
      codeMsg = (err && (err.description || err.message)) || 'That did not go through. Please try again.';
      return refresh();
    }).then(done, done);
  }
  /* Codes are additive: a new code joins the ones already working (the
     customer's own credit code among them) instead of replacing them. A code
     Shopify will not honour is taken off again at once, leaving the others,
     so the bag never carries a dead code into checkout. */
  function liveCodes(c) {
    return ((c || cart || {}).discount_codes || []).filter(function (d) { return d.applicable; })
      .map(function (d) { return d.code; });
  }
  function isCredit(code) {
    return !!(O.credit && code && String(code).toUpperCase() === String(O.credit.code).toUpperCase());
  }
  function applyCode(code, origin) {
    busy(true); changed = true;
    var keep = liveCodes().filter(function (k) { return k.toUpperCase() !== String(code).toUpperCase(); });
    var ok = false;
    return api('/update.js', { discount: keep.concat([code]).join(',') }).then(function (c) {
      var bad = (c.discount_codes || []).filter(function (d) { return !d.applicable; });
      if (bad.length) {
        codeMsg = isCredit(bad[0].code)
          ? 'Your credit could not be added to this bag. Please try again, or message us on WhatsApp.'
          : 'Code ' + bad[0].code + ' does not apply to this bag, or a better offer is already applied.';
        return api('/update.js', { discount: keep.join(',') });
      }
      ok = true;
    })['catch'](function () { codeMsg = 'That code could not be applied. Please try again.'; })
      .then(refresh).then(function () {
        done();
        if (ok && isCredit(code) && window.GYFx) { window.GYFx.celebrate(2, origin); }
      }, done);
  }
  function removeCode(code) {
    var keep = liveCodes().filter(function (k) { return k.toUpperCase() !== String(code).toUpperCase(); });
    return mutate(api('/update.js', { discount: keep.join(',') }));
  }

  /* The customer's GraceYes credit (sections/gy-my-graceyes.liquid has the
     whole story). They apply it themselves, with one tap: owned, not automatic.
     O.credit is set only for a logged-in customer with a balance. */
  function creditHtml(c) {
    var cr = O.credit;
    if (!cr || !(cr.bal > 0) || !cr.code) { return ''; }
    var on = liveCodes(c).some(isCredit);
    if (on) {
      var used = 0;
      (c.cart_level_discount_applications || []).forEach(function (d) {
        if (isCredit(d.title) || isCredit(d.code)) { used += d.total_allocated_amount; }
      });
      return '<div class="gyc-credit is-on" role="status"><span class="gyc-credit__tick" aria-hidden="true">✓</span>' +
        '<span class="gyc-credit__txt"><b>' + (used ? money(used) + ' of your credit is in use' : 'Your credit is in use') + '</b>' +
        '<small>' + (cr.bal > used && used ? money(cr.bal - used) + ' stays saved for next time' : 'Thank you for coming back to us') + '</small></span>' +
        '<button type="button" class="gyc-credit__off" data-gyc-credit-off>Remove</button></div>';
    }
    return '<button type="button" class="gyc-credit" data-gyc-credit>' +
      '<span class="gyc-credit__coin" aria-hidden="true">₹</span>' +
      '<span class="gyc-credit__txt"><b>Use my ' + money(cr.bal) + ' GraceYes credit</b>' +
      '<small>' + (cr.exp ? 'Yours until ' + esc(cr.exp) + ' · ' : '') + '10% back from your earlier orders</small></span>' +
      '<span class="gyc-credit__go" aria-hidden="true">Apply</span></button>';
  }

  /* Shopflo's checkout does not read the codes on the Shopify cart. Its
     bundle (bridge.shopflo.com shopflo.bundle.js, read 08 Oct 2026) takes
     them from cookies, first match wins: `discount_code` (one code, the
     cookie Shopify's /discount/CODE links set), then `coupon_applied`
     (comma-separated), then `hscodediscount`. So every time the bag renders,
     the codes that are really working on the cart are written to
     coupon_applied and discount_code is cleared, or a single code left there
     by an old /discount link would hide the rest (the customer's credit
     among them). The cart stays the source of truth; the cookie follows it. */
  function syncFloCodes(c) {
    var live = liveCodes(c), domain = '';
    var host = window.location.hostname.replace(/^www\./, '');
    if (host.indexOf('.') > 0 && !/myshopify\.com$/.test(host)) { domain = '; domain=.' + host; }
    var tail = '; path=/; SameSite=Lax' + (window.location.protocol === 'https:' ? '; Secure' : '');
    try {
      document.cookie = 'discount_code=; Max-Age=0' + tail;
      document.cookie = 'discount_code=; Max-Age=0' + tail + domain;
      if (live.length) {
        document.cookie = 'coupon_applied=' + encodeURIComponent(live.join(',')).replace(/%2C/g, ',') + '; Max-Age=86400' + tail;
      } else {
        document.cookie = 'coupon_applied=; Max-Age=0' + tail;
      }
    } catch (err) { /* cookies blocked: Shopflo opens without the codes, the cart still has them */ }
  }

  /* ---------------------------------------------------------------- render */
  function render() {
    var c = cart, e = estimate(c);
    syncFloCodes(c);
    badges(c.item_count);
    elCount.textContent = c.item_count ? '(' + c.item_count + ')' : '';
    renderRewards(c, e);
    if (!c.item_count) { renderEmpty(); return; }

    var inCart = {};
    c.items.forEach(function (it) { inCart[it.handle] = (inCart[it.handle] || 0) + it.quantity; });

    var html = c.items.map(function (it, i) { return lineHtml(it, i + 1, e); }).join('');
    html += bundleHtml(inCart, e);
    html += upsellHtml(inCart, e);
    html += summaryHtml(c, e);
    var keep = elBody.scrollTop;
    elBody.innerHTML = html;
    elBody.scrollTop = keep;
    renderFoot(c, e);
  }

  function renderRewards(c, e) {
    var sub = c.items_subtotal_price;
    var reached = stepsReached(sub, e.total);
    var next = STEPS[reached];
    var msg;
    if (!c.item_count) { msg = O.freeShip > 0 ? 'Free shipping over <b>' + money(O.freeShip) + '</b>, and up to <b>15% off</b> as you add more.' : '<b>Free shipping on every order</b>, and up to <b>15% off</b> as you add more.'; }
    else if (next) {
      var gap = next.pct ? next.at - sub : next.at - e.total;
      msg = 'Add <b>' + money(gap) + '</b> more to unlock <b>' + next.label + '</b>';
    } else { msg = 'You have unlocked everything: <b>free shipping and 15% off</b>'; }

    /* Four equal segments, so the first two milestones do not crowd together. */
    var n = STEPS.length, pos = 0;
    if (reached >= n) { pos = 100; }
    else {
      var lo = reached ? STEPS[reached - 1].at : 0, hi = STEPS[reached].at;
      var val = STEPS[reached].pct ? sub : e.total;
      pos = (reached + Math.max(0, Math.min(1, (val - lo) / (hi - lo)))) / n * 100;
    }
    var nodes = STEPS.map(function (s, i) {
      var inner = s.icon
        ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M1 6h13v10H1zM14 10h5l3 3v3h-8z"/><circle cx="6" cy="18" r="2"/><circle cx="18" cy="18" r="2"/></svg>'
        : s.pct + '%';
      return '<i class="gyc-rw__node' + (i < reached ? ' is-on' : '') + '" style="left:' + ((i + 1) / n * 100) + '%">' + inner +
             '<span>' + s.short + '<br>' + money(s.at) + '</span></i>';
    }).join('');
    elRewards.innerHTML = '<p class="gyc-rw__msg" role="status">' + msg + '</p>' +
      '<div class="gyc-rw__track"><div class="gyc-rw__fill" style="width:' + pos.toFixed(1) + '%"></div>' + nodes + '</div>';
  }

  /* Pack variants (16 Oct 2026): "Pack of 2" is one line holding two pieces. */
  function packUnits(it) { var m = /Pack of (\d+)/.exec(it.variant_title || ''); return m ? Number(m[1]) : 1; }

  function lineHtml(it, line, e) {
    var p = byHandle[it.handle] || {};
    var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : (p.img || '');
    var u = packUnits(it);
    var compare = (p.c && p.c * u > it.final_price) ? p.c * u : (it.original_price > it.final_price ? it.original_price : 0);
    var disc = (it.line_level_discount_allocations || []).map(function (d) {
      return '<p class="gyc-line__disc">' + esc(d.discount_application.title) + ' (−' + money(d.amount) + ')</p>';
    }).join('');
    return '<div class="gyc-line">' +
      '<a class="gyc-line__img" href="' + esc(it.url) + '"><img src="' + esc(img) + '" alt="" width="76" height="67"></a>' +
      '<div><div class="gyc-line__top"><div>' +
        '<a class="gyc-line__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
        ((p.q || u > 1) ? '<p class="gyc-line__meta">' + esc([p.q, u > 1 ? it.variant_title : ''].filter(Boolean).join(' · ')) + '</p>' : '') +
      '</div><button type="button" class="gyc-line__rm" data-gyc-set="' + line + ':0" aria-label="Remove ' + esc(it.product_title) + '">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13"/></svg></button></div>' +
      '<div class="gyc-line__row"><div class="gyc-qty">' +
        '<button type="button" data-gyc-set="' + line + ':' + (it.quantity - 1) + '" aria-label="Decrease quantity">−</button>' +
        '<span aria-label="Quantity">' + it.quantity + '</span>' +
        '<button type="button" data-gyc-set="' + line + ':' + (it.quantity + 1) + '" aria-label="Increase quantity">+</button></div>' +
        '<span class="gyc-price">' + money(it.final_line_price) + (compare ? '<del>' + money(compare * it.quantity) + '</del>' : '') + '</span></div>' +
      disc + '</div>' + packHtml(it, line, e) + '</div>';
  }

  /* One-tap pack: offered only when taking 2 (or 3) of the same thing unlocks
     a reward the basket does not have yet. */
  function packHtml(it, line, e) {
    if (it.quantity !== 1 || packUnits(it) > 1) { return ''; }
    var sub = cart.items_subtotal_price;
    var now = stepsReached(sub, e.total);
    if (now >= STEPS.length) { return ''; }
    for (var n = 2; n <= 3; n++) {
      var nsub = sub + it.final_price * (n - 1);
      var o = outcome(nsub);
      var then = stepsReached(nsub, o.after);
      if (then > now) {
        var gain = STEPS[then - 1].label.toLowerCase();
        if (O.freeShip > 0 && then > 1 && now === 0) { gain = 'free shipping + ' + gain; }
        return '<button type="button" class="gyc-pack" data-gyc-set="' + line + ':' + n + '">' +
          '<span class="gyc-pack__box" aria-hidden="true"></span>' +
          '<span><b>Make it a pack of ' + n + '</b> · +' + money(it.final_price * (n - 1)) + '<br><em>Unlocks ' + gain + '</em></span></button>';
      }
    }
    return '';
  }

  /* Shown while there is still a reward to earn, for the routine the bag is
     closest to completing. */
  function bundleHtml(inCart, e) {
    if (stepsReached(cart.items_subtotal_price, e.total) >= STEPS.length) { return ''; }
    var best = null;
    BUNDLES.forEach(function (b) {
      var have = b.items.filter(function (h) { return inCart[h]; }).length;
      if (!have || have === b.items.length) { return; }
      var missing = b.items.filter(function (h) { return !inCart[h]; });
      if (!missing.every(function (h) { return byHandle[h] && byHandle[h].a; })) { return; }
      var score = have / b.items.length;
      if (!best || score > best.score) { best = { b: b, missing: missing, score: score }; }
    });
    if (!best) { return ''; }
    var add = best.missing.reduce(function (s, h) { return s + byHandle[h].p; }, 0);
    var nsub = cart.items_subtotal_price + add;
    var o = outcome(nsub);
    var perk = o.pct > e.pct ? '<b>' + o.pct + '% off the whole bag</b>' + (e.free ? '' : ' and free shipping')
                             : (o.free && !e.free ? '<b>free shipping</b>' : '');
    var set = best.missing.map(function (h) { return byHandle[h].id + ':1'; }).join(',');
    return '<div class="gyc-bundle"><p class="gyc-bundle__eyebrow">Complete the routine</p>' +
      '<p class="gyc-bundle__name">' + esc(best.b.name) + '</p>' +
      '<div class="gyc-bundle__items">' + best.b.items.map(function (h, i) {
        var p = byHandle[h]; if (!p) { return ''; }
        return (i ? '<span class="gyc-bundle__plus">+</span>' : '') +
          '<span class="gyc-bundle__it' + (inCart[h] ? ' is-in' : '') + '" title="' + esc(p.t) + '"><img src="' + esc(p.img) + '" alt="' + esc(p.t) + '" width="54" height="47"></span>';
      }).join('') + '</div>' +
      '<p class="gyc-bundle__txt">Add ' + best.missing.map(function (h) { return esc(byHandle[h].t); }).join(' and ') + ' for ' + money(add) +
        (perk ? ' and get ' + perk : '') + '.</p>' +
      '<button type="button" class="gyc-btn" data-gy-add-set="' + set + '">Add ' + (best.missing.length > 1 ? 'all ' + best.missing.length : 'it') + ' · ' + money(add) + '</button></div>';
  }

  function upsellHtml(inCart, e) {
    var picks = recommend(inCart, e, 6);
    if (!picks.length) { return ''; }
    return '<p class="gyc-h">Goes well with your bag</p><div class="gyc-rail">' + picks.map(upCard).join('') + '</div>';
  }
  function upCard(x) {
    var p = x.p;
    return '<div class="gyc-up"><a class="gyc-up__img" href="/products/' + esc(p.h) + '"><img src="' + esc(p.img) + '" alt="' + esc(p.t) + '" loading="lazy" width="132" height="116">' +
      (x.tag ? '<span class="gyc-up__tag">' + esc(x.tag) + '</span>' : '') + '</a>' +
      '<div class="gyc-up__b"><a class="gyc-up__name" href="/products/' + esc(p.h) + '">' + esc(p.t) + '</a>' +
      '<span class="gyc-price">' + money(p.p) + (p.c > p.p ? '<del>' + money(p.c) + '</del>' : '') + '</span>' +
      '<button type="button" class="gyc-btn gyc-up__add" data-gy-add-set="' + p.id + ':1">+ Add</button></div></div>';
  }

  /* Curated companions first (snippets/gy-offers.liquid), newest line first,
     then bestsellers. Whatever closes the gap to the next reward most cheaply
     is lifted to the front and labelled. */
  function recommend(inCart, e, limit) {
    var seen = {}, out = [];
    function push(h, w) {
      var p = byHandle[h];
      if (!p || !p.a || inCart[h] || seen[h]) { return; }
      seen[h] = 1; out.push({ p: p, w: w, tag: '' });
    }
    var items = cart ? cart.items : [];
    for (var rank = 0; rank < 3; rank++) {
      items.forEach(function (it, i) { var prs = PAIRS[it.handle] || []; if (prs[rank]) { push(prs[rank], 100 - rank * 10 - i); } });
    }
    O.bestsellers.forEach(function (h, i) { push(h, 20 - i); });

    if (cart && cart.item_count) {
      var sub = cart.items_subtotal_price, now = stepsReached(sub, e.total);
      if (now < STEPS.length) {
        var closer = null;
        out.forEach(function (x) {
          var o = outcome(sub + x.p.p);
          var then = stepsReached(sub + x.p.p, o.after);
          if (then > now) {
            x.tag = 'Unlocks ' + STEPS[then - 1].short.toLowerCase();
            if (!closer || x.p.p < closer.p.p) { closer = x; }
          }
        });
        if (closer) { closer.w += 60; }
      }
    }
    out.sort(function (a, b) { return b.w - a.w; });
    return out.slice(0, limit);
  }

  function renderEmpty() {
    var picks = recommend({}, { total: 0, free: false }, 6);
    elBody.innerHTML = '<p class="gyc__empty"><b>Your bag is empty</b>Seventy-five things are waiting, and we make all of them ourselves.</p>' +
      (picks.length ? '<p class="gyc-h">Most loved</p><div class="gyc-rail">' + picks.map(upCard).join('') + '</div>' : '') +
      '<p style="margin-top:20px"><a class="gyc-btn gyc-btn--ghost" href="/collections/all">See everything we make</a></p>';
    elFoot.hidden = true; elFoot.innerHTML = '';
  }

  /* The order summary scrolls with the bag; only the total and the checkout
     button stay pinned, so a short phone screen still shows the products. */
  function summaryHtml(c, e) {
    var mrp = 0;
    c.items.forEach(function (it) { var p = byHandle[it.handle]; var u = packUnits(it); var cmp = p && p.c * u > it.original_price ? p.c * u : it.original_price; mrp += cmp * it.quantity; });
    var codes = (c.discount_codes || []).filter(function (d) { return d.applicable; });
    var rows = '<div class="gyc-sum"><span>Subtotal</span><span>' + money(c.original_total_price) + '</span></div>';
    var shown = 0;
    (c.cart_level_discount_applications || []).forEach(function (d) {
      shown += d.total_allocated_amount;
      var label = (isCredit(d.title) || isCredit(d.code)) ? 'GraceYes credit' : d.title;
      rows += '<div class="gyc-sum gyc-sum--save"><span>' + esc(label) + '</span><span>−' + money(d.total_allocated_amount) + '</span></div>';
    });
    if (c.total_discount > shown) {
      rows += '<div class="gyc-sum gyc-sum--save"><span>Discounts</span><span>−' + money(c.total_discount - shown) + '</span></div>';
    }
    if (e.est) {
      rows += '<div class="gyc-sum gyc-sum--save"><span>Milestone ' + e.pct + '% off</span><span>−' + money(e.est) + '</span></div>';
    }
    rows += '<div class="gyc-sum' + (e.free ? ' gyc-sum--save' : '') + '"><span>Shipping</span><span>' + (e.free ? 'FREE' : money(e.ship)) + '</span></div>';
    var saved = (mrp - c.original_total_price) + c.total_discount + e.est + (e.free ? O.shipFee : 0);
    var chips = codes.filter(function (d) { return !isCredit(d.code); }).map(function (d) {
      return '<span class="gyc-chip">' + esc(d.code) + '<button type="button" data-gyc-code-remove="' + esc(d.code) + '" aria-label="Remove code ' + esc(d.code) + '">&times;</button></span>';
    }).join('');
    var html = '<div class="gyc-summary"><p class="gyc-h">Order summary</p>' + rows +
      (saved > 0 ? '<p class="gyc-saved">You are saving ' + money(saved) + ' on this order</p>' : '') +
      creditHtml(c) +
      '<details class="gyc-code"' + (codeMsg || chips ? ' open' : '') + '><summary>Have a discount or creator code?</summary>' +
        '<form class="gyc-code__row" data-gyc-code><input type="text" name="code" autocomplete="off" autocapitalize="characters" placeholder="Enter code" aria-label="Discount code">' +
        '<button type="submit" class="gyc-btn gyc-btn--ghost">Apply</button></form>' +
        (codeMsg ? '<p class="gyc-code__msg" role="alert">' + esc(codeMsg) + '</p>' : '') + chips + '</details>' +
      (e.est ? '<p class="gyc-note">Milestone discount is applied at checkout.</p>' : '') + '</div>';
    codeMsg = '';
    return html;
  }

  function renderFoot(c, e) {
    var total = e.total + e.ship;
    elFoot.innerHTML =
      '<div class="gyc-sum gyc-sum--total"><span>Total <small>incl. taxes' + (e.free ? ' and shipping' : ', + ' + money(e.ship) + ' shipping') + '</small></span><span>' + money(e.total) + '</span></div>' +
      '<a class="gyc-btn gyc-btn--go" href="/checkout" data-gyc-checkout>Checkout · ' + money(total) + '</a>' +
      /* Magic Checkout offers cash on delivery only up to ₹999. */
      '<ul class="gyc-trust"><li>' + (e.total <= 99900 ? 'Cash on delivery' : 'COD up to ₹999') + '</li><li>UPI, cards, net banking</li><li>Made in small batches</li></ul>';
    elFoot.hidden = false;
  }

  function badges(count) {
    Array.prototype.forEach.call(document.querySelectorAll('.gy-header__count'), function (b) {
      b.textContent = count; b.hidden = !count;
    });
  }

  /* ---------------------------------------------------------- open / close */
  function open() {
    /* Let the add-to-cart photo land in the bag icon first (snippets/gy-atc-fx). */
    var wait = (window.__gyFlyEnd || 0) - Date.now();
    if (wait > 0) { return new Promise(function (r) { setTimeout(function () { r(open()); }, wait); }); }
    if (!root.hidden && root.classList.contains('is-open')) { return refresh(); }
    lastFocus = document.activeElement;
    root.hidden = false;
    document.body.classList.add('gyc-lock');
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    root.querySelector('.gyc__panel').focus({ preventScroll: true });
    elBody.scrollTop = 0;
    return refresh();
  }
  function close() {
    root.classList.remove('is-open');
    document.body.classList.remove('gyc-lock');
    setTimeout(function () { if (!root.classList.contains('is-open')) { root.hidden = true; } }, 380);
    if (lastFocus && document.contains(lastFocus)) { lastFocus.focus({ preventScroll: true }); }
    /* The cart page is server-rendered; bring it back in step. */
    if (O.isCartPage && changed) { window.location.reload(); }
  }
  window.GYBag = { open: open, close: close, refresh: refresh };
  /* Markup written for Shopflo still calls these by name. They now lead to
     Shopify's own checkout; Buy now is handled by the click listener below. */
  window.handleFloCheckoutBtn = function () { window.location.href = '/checkout'; };
  window.handleFloBuyNowBtn = function () {};
  window.handleFloCartBtn = open;

  function parseSet(str) {
    return str.split(',').map(function (pair) { var p = pair.split(':'); return { id: Number(p[0]), quantity: Number(p[1] || 1) }; });
  }

  /* --------------------------------------------------------------- wiring */
  function isBagLink(a) {
    if (!a || a.target === '_blank' || a.hasAttribute('download')) { return false; }
    if (a.host && a.host !== location.host) { return false; }
    return (a.pathname || '').replace(/\/+$/, '') === CART;
  }

  document.addEventListener('click', function (ev) {
    if (ev.defaultPrevented || ev.button !== 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) { return; }
    var t = ev.target; if (!t || !t.closest) { return; }

    if (t.closest('[data-gyc-close]')) { ev.preventDefault(); close(); return; }

    var setBtn = t.closest('[data-gyc-set]');
    if (setBtn) {
      ev.preventDefault();
      var v = setBtn.getAttribute('data-gyc-set').split(':');
      mutate(api('/change.js', { line: Number(v[0]), quantity: Math.max(0, Number(v[1])) }));
      return;
    }
    var addSet = t.closest('[data-gy-add-set]');
    if (addSet) {
      ev.preventDefault();
      addSet.disabled = true;
      var wasOpen = root.classList.contains('is-open');
      var job = api('/add.js', { items: parseSet(addSet.getAttribute('data-gy-add-set')) });
      if (wasOpen) { mutate(job); }
      else { job.then(function () { changed = true; addSet.disabled = false; open(); })['catch'](function () { addSet.disabled = false; open(); }); }
      return;
    }
    var rm = t.closest('[data-gyc-code-remove]');
    if (rm) { ev.preventDefault(); removeCode(rm.getAttribute('data-gyc-code-remove') || ''); return; }
    var cred = t.closest('[data-gyc-credit]');
    if (cred) {
      ev.preventDefault();
      var r = cred.getBoundingClientRect();
      applyCode(O.credit.code, { x: r.left + r.width / 2, y: r.top + r.height / 2 });
      return;
    }
    if (t.closest('[data-gyc-credit-off]')) { ev.preventDefault(); removeCode(O.credit.code); return; }

    var buyNow = t.closest('[data-gy-buy-now], #flo-buy-now-button');
    if (buyNow) {
      var form = buyNow.closest('form') || document.getElementById(buyNow.getAttribute('form'));
      if (!form) { return; }
      ev.preventDefault();
      buyNow.disabled = true;
      api('/add.js', new FormData(form)).then(function () { window.location.href = '/checkout'; })
        ['catch'](function () { buyNow.disabled = false; form.submit(); });
      return;
    }

    var link = t.closest('a[href]');
    if (isBagLink(link) && !link.closest('#GyBag')) { ev.preventDefault(); open(); }
  });

  document.addEventListener('submit', function (ev) {
    if (ev.defaultPrevented) { return; }
    var form = ev.target;
    if (!form || form.tagName !== 'FORM') { return; }

    if (form.hasAttribute('data-gyc-code')) {
      ev.preventDefault();
      var code = (form.elements.code.value || '').trim();
      if (code) { applyCode(code); }
      return;
    }
    if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) { return; }
    ev.preventDefault();
    var btn = form.querySelector('button[type="submit"], input[type="submit"]');
    var was = btn ? btn.disabled : false;
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    function release() { if (btn) { btn.disabled = was; btn.removeAttribute('aria-busy'); } }
    api('/add.js', new FormData(form)).then(function () { changed = true; release(); open(); })
      ['catch'](function () { release(); form.submit(); });
  });

  document.addEventListener('keydown', function (ev) {
    if (root.hidden) { return; }
    if (ev.key === 'Escape') { ev.preventDefault(); close(); return; }
    if (ev.key !== 'Tab') { return; }
    var f = Array.prototype.filter.call(root.querySelectorAll('a[href], button:not([disabled]), input, summary'), function (el) { return el.offsetParent !== null; });
    if (!f.length) { return; }
    if (ev.shiftKey && document.activeElement === f[0]) { ev.preventDefault(); f[f.length - 1].focus(); }
    else if (!ev.shiftKey && document.activeElement === f[f.length - 1]) { ev.preventDefault(); f[0].focus(); }
  });

  /* A link such as /?bag=open (ads, WhatsApp recovery messages) opens the bag. */
  if (/[?&]bag=open\b/.test(location.search)) { open(); }
})();
